import { MRT_ColumnDef, MRT_Column, MRT_Cell } from "material-react-table";
import { Accessor } from "../../../utilities/types";
import { Checkbox, FormControlLabel } from "@mui/material";
import type { BaseDataModel } from "../../../api/types";

interface CheckboxColumnOptions<T extends BaseDataModel> {
	accessorKeyOrFn?: Accessor<boolean, T>;
}

export const checkboxColumn = <T extends BaseDataModel>(
	header: string,
	{ accessorKeyOrFn = undefined }: CheckboxColumnOptions<T> = {},
) =>
	({
		id: header.toLowerCase(),

		accessorFn: (row) =>
			typeof accessorKeyOrFn === "function"
				? accessorKeyOrFn(row)
				: accessorKeyOrFn
					? ((row[accessorKeyOrFn] as boolean | undefined) ?? false)
					: false,

		header,
		size: 100,

		// filterVariant: 'checkbox',
		Filter: ({ column }: { column: MRT_Column<T, unknown> }) => (
			<FormControlLabel
				control={
					<Checkbox
						checked={column.getFilterValue() === true}
						color={column.getFilterValue() === undefined ? "default" : "primary"}
						indeterminate={column.getFilterValue() === undefined}
						size="small"
						onChange={() => {
							column.setFilterValue(
								column.getFilterValue() === undefined ? true : column.getFilterValue() === true ? false : undefined,
							);
						}}
						sx={() => ({
							height: "2.5rem",
							width: "2.5rem",
						})}
					/>
				}
				disableTypography
				label={column.getFilterValue() === undefined ? "Yes & No" : column.getFilterValue() === true ? "Yes" : "No"}
				sx={{ color: "text.secondary", fontWeight: "normal", mt: "-4px" }}
				title={undefined}
			/>
		),

		Cell: ({ cell }: { cell: MRT_Cell<T, unknown> }) => {
			const value = cell.getValue<boolean>();
			return <Checkbox style={{ margin: 0, padding: 0 }} checked={value} readOnly={true} />;
		},

		filterFn: (row, columnId, filterValue) => {
			// Handle 3-state filtering: undefined (show all), true (show only true), false (show only false)
			if (filterValue === undefined) {
				return true; // Show all rows when filter is undefined
			}

			const cellValue = row.getValue<boolean>(columnId);
			return cellValue === filterValue;
		},
	}) as MRT_ColumnDef<T>;
